import { Button } from '@sixfold/common-ui';
import { Localized } from '@sixfold/localization-component';
import { isNil } from '@sixfold/typed-primitives';
import * as React from 'react';
import { Navigate, useLocation } from 'react-router';

import { Footer } from '../../components/footer/footer';
import { MapPageFrame } from '../../components/map_page_frame';
import * as Routes from '../../lib/routes';
import { useProductName } from '../../lib/use_product_name';
import { navigateToLocationWithServerSideRendering } from '../../lib/util';

export const SharedViewInvitationLoginContainer: React.FC = () => {
  const productName = useProductName();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const token = query.get('token');
  const footer = React.useMemo(() => <Footer />, []);

  if (isNil(token)) {
    return <Navigate to={Routes.LandingPage.routerPath} replace />;
  }

  return (
    <MapPageFrame showHeader={true} footer={footer}>
      <Button
        fullWidth
        kind="primary"
        onClick={() => {
          navigateToLocationWithServerSideRendering(Routes.SharedViewInvitationLoginToken.generatePath({ token }));
        }}>
        <Localized id="sharedView.picker.button.navigate">Navigate to {{ PRODUCT_NAME: productName }}</Localized>
      </Button>
    </MapPageFrame>
  );
};
